import React, { Component, ReactNode } from "react";
import classnames from "classnames";
import { addSeconds, subMinutes } from "date-fns";

import { IStreamData } from "@formant/core/model/IStreamData";
import { StreamType } from "@formant/core/model/StreamType";

import { observeStore, queryStore } from "../../stores";
import * as styles from "./BaseListModule.scss";
import { IBaseModuleProps } from "./IBaseModuleProps";
import { Module } from "./Module";
import { flattenPoints } from "./utils/flattenPoints";
import { IMetadataDataPoint } from "./utils/IMetadataDataPoint";

export abstract class BaseListModule<
    T extends StreamType = StreamType,
> extends Component<IBaseModuleProps> {
    protected abstract type: T;
    protected abstract listItem: (
        point: IMetadataDataPoint<T>,
        i: number,
    ) => ReactNode;

    private data: IStreamData<T>[] = [];

    public render() {
        const { type, listItem } = this;
        const { streamName, filter, focused } = this.props;

        const { time } = observeStore;
        const startTime = subMinutes(time, 10);
        const endTime = addSeconds(time, 1);

        const queryData = queryStore.moduleQuery(
            filter,
            streamName,
            type,
            startTime,
            endTime,
        );

        const loading = queryData === undefined;

        const tooMuchData = queryData === "too much data";
        this.data = (queryData !== "too much data" && queryData) || this.data;
        const data = this.data;

        const all = flattenPoints(data).slice().reverse();

        const points: IMetadataDataPoint<T>[] = [];

        let lastKey: string = "";
        for (const point of all) {
            if (points.length === 25) {
                break;
            }
            const key = JSON.stringify({ ...point, time: undefined });
            if (key !== lastKey) {
                lastKey = key;
                points.push(point);
            }
        }

        const empty = points.length === 0;

        return (
            <Module
                {...this.props}
                type={type}
                loading={loading}
                empty={empty}
                tooMuchData={tooMuchData}
                className={classnames(
                    styles["base-list-module"],
                    focused && styles.focused,
                )}
            >
                <div className={styles.list}>{points.map(listItem)}</div>
            </Module>
        );
    }
}
